var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Wunsch-Job veröffentlichen",
        size: "lg",
        "ok-text": "Jetzt veröffentlichen",
        "hide-ok": !_vm.publishable,
        "hide-cancel": _vm.publishing,
        "cancel-text": _vm.publishable ? "Abbrechen" : "Schließen",
        "ok-disabled": _vm.publishing,
        "ok-loading": _vm.publishing
      },
      on: {
        ok: _vm.publish,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _vm.publishable
        ? _c("div", [
            _vm._v(
              "\n\t\tNach Veröffentlichung scheint dein Wunsch-Job auch für Firmen auf um dich kontaktieren zu können.\n\t"
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }